import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';

import { 
    Button,
    Checkbox, 
    FormControlLabel, 
    IconButton, 
    Paper, 
    Table, 
    TableBody, 
    TableCell, 
    TableContainer, 
    TableHead, 
    TableRow, 
    Tooltip, 
    Typography
} from '@mui/material'
import { collection, getDocs } from 'firebase/firestore';
import { auth, db } from '../firebase/firebase';

const ColeccionesCheckBox = (props) => {

    const {coleccionesDiagrama, setColeccionesDiagrama} = props;

    const user = auth.currentUser;
    const [colecciones, setColecciones] = useState([]);
    const [arregloActual, setArregloActual] = useState(coleccionesDiagrama);

    useEffect(() => {
        obtenerColecciones();
    }, [])


    const obtenerColecciones = async() =>{

        let arrayAux = [];

        try {

            const querySnapshot = await getDocs(collection(db, 'colecciones'));
            querySnapshot.docs.forEach( (doc) => {
            if(doc.data().usuario === user.uid){
                arrayAux.push({id: doc.id, ...doc.data()});
            }
            }); 
            setColecciones(arrayAux);

        } catch (error) {


        }
    }

    const handleCheckBox = (nombre, id) =>{
        let actualizar = true;
        let arrayAux = arregloActual;

        let nuevo = {
            id: id, 
            nombre: nombre
        }

        arregloActual.map((diagram, index)=>{
            if(diagram.id === nuevo.id){
              arrayAux.splice(index, 1)
              actualizar = false;
            }
        })

        if(actualizar){
          arrayAux.push(nuevo)
        }
        setArregloActual(arrayAux)
        /* console.log(coleccionesDiagrama)
        console.log(arregloActual) */
        obtenerColecciones();
    }


    return (
        <TableContainer component={Paper} >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography
                    variant='h6'
                    sx={{ fontWeight: 'bold' }}
                  >
                    Titulo
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                      variant='h6'
                      sx={{ fontWeight: 'bold' }}
                    >
                      ID
                    </Typography>
                </TableCell>

                <TableCell align="right">
                  <Typography
                      variant='h6'
                      sx={{ fontWeight: 'bold' }}
                    >
                      Acciones
                    </Typography>
                </TableCell>

                <TableCell align="right">
                  <Typography
                      variant='h6'
                      sx={{ fontWeight: 'bold' }}
                    >
                      Acciones
                    </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                colecciones.map((row, i)=>(
                  <TableRow key={i}>
                    <TableCell component="th" scope="row">
                      {row.nombre}
                    </TableCell>

                    <TableCell>
                      {row.id}
                    </TableCell>

                    <TableCell>
                      {row.color}
                    </TableCell>

                    <TableCell align="right">
                        <> 
                            {
                              (arregloActual.some(diagrama => {
                                if(diagrama.id === row.id){
                                  return true;
                                }
                                else{
                                  return false
                                }
                              })) ?
                              (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      onChange={()=>{handleCheckBox(row.nombre, row.id)}}
                                      checked={true}
                                    />
                                  }
                                />
                              )
                              :
                              (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      onChange={()=>{handleCheckBox(row.nombre, row.id)}}
                                      checked={false}
                                    />
                                  }
                                />
                              )
                            }
                        </>
                    </TableCell>

                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </TableContainer>
    )
}

export default ColeccionesCheckBox